module.exports = __webpack_public_path__ + "static/CareLabel-v6-no-border-7a2512953a699a6c21c035e0524301ab.svg";